module.exports = __webpack_public_path__ + "static/Bronze-e264d20deb8939e6dcf19445d5213e22.jpg";